import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Sparkles,
  Droplets,
  History,
  UserRound,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard },
  { to: "/health-ai", label: "Health AI", icon: Sparkles },
  { to: "/diabetes", label: "Diabetes", icon: Droplets },
  { to: "/history", label: "History", icon: History },
  { to: "/profile", label: "Profile", icon: UserRound },
];

export default function MobileBottomNav() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <nav
      data-testid="mobile-bottom-nav"
      aria-label="Primary"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 glass-header border-t border-white/[0.07] pb-safe"
    >
      <div className="grid grid-cols-5">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`mobile-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 min-h-[56px] py-2 transition-colors ${
                isActive ? "text-cyan-300" : "text-zinc-500 hover:text-zinc-300"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className="relative">
                  <Icon className="w-5 h-5" strokeWidth={isActive ? 2.4 : 2} />
                  {isActive && (
                    <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-cyan-400" />
                  )}
                </span>
                <span className="text-[10px] font-medium tracking-tight leading-none">
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
